import navigateToConversation from './lib/navigate_to_conversation';

export default class NavigateToConversation {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, conversationId, conversationItemId }) {
    navigateToConversation(this.context, { customerId, conversationId, conversationItemId });
  }
}
